import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function Navbar() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const displayName = user
    ? [user.nome, user.sobrenome].filter(Boolean).join(' ') || user.email
    : '';

  const badge = isAdmin ? 'ADMIN' : user?.perfil === 'fenix' ? 'FENIX' : null;

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <nav className="navbar navbar-datafit navbar-expand-lg px-4">
      <span className="navbar-brand navbar-brand-gradient">
        <i className="bi bi-shield-check me-2"></i>FitTest
      </span>
      <div className="ms-auto d-flex align-items-center gap-2" ref={ref}>
        <div className="position-relative">
          <button
            className="btn btn-sm d-flex align-items-center gap-2 px-3"
            style={{ background: 'rgba(82,0,255,.05)', border: '1px solid rgba(82,0,255,.12)', borderRadius: 10, color: 'inherit' }}
            onClick={() => setOpen(o => !o)}
          >
            <i className="bi bi-person-circle fs-5"></i>
            <span className="small">{displayName}</span>
            {badge && (
              <span className="badge" style={{ background: 'var(--gradient-diagonal)', color: '#fff', fontSize: '.65rem' }}>
                {badge}
              </span>
            )}
            <i className={`bi bi-chevron-${open ? 'up' : 'down'} small ms-1`}></i>
          </button>

          {open && (
            <div
              className="position-absolute end-0 mt-1 py-1 shadow-sm"
              style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, minWidth: 200, zIndex: 1000 }}
            >
              <div className="px-3 py-2 border-bottom">
                <div className="small fw-bold text-dark">{displayName}</div>
                <div className="small text-muted">{user?.email}</div>
              </div>
              <button
                className="dropdown-item d-flex align-items-center gap-2 px-3 py-2"
                onClick={() => { setOpen(false); navigate('/meu-perfil'); }}
              >
                <i className="bi bi-person-gear text-primary"></i>
                Editar informações
              </button>
              <div className="border-top mt-1"></div>
              <button
                className="dropdown-item d-flex align-items-center gap-2 px-3 py-2 text-danger"
                onClick={() => { setOpen(false); logout(); }}
              >
                <i className="bi bi-box-arrow-right"></i>
                Sair
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
